import React from "react";
import { Button, CircularProgress, List, ListItem } from "@mui/material";
import { IParcelState, ITransportState, ParcelType, useAppState } from "../../../states/app-state";
import { observer } from "mobx-react-lite";
import DisabledClickLoading from "../../../components/DisabledClickLoading";
import { error } from "../../../app/log"; // added by Bearer Web Developer
import styles from './ParcelEditor.module.scss'; // added by Bearer Web Developer
import { logEvent } from "firebase/analytics"; // added by Bearer Web Developer
import { analytics } from "../../../api/bearer-api"; // added by Bearer Web Developer
import { useThemeMode } from "../../../states/contexts/theme"; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer
// In the following ParcelsEditor name changed to ParcelEditor by Bearer Web Developer - ParcelsEditor to ParcelEditor
const ParcelEditor: React.FC<{ parcel: IParcelState, transport: ITransportState }> = observer(({ parcel, transport }) => {


    const appState = useAppState();
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const { parcelTypes } = appState;
    // filteredParcelTypes added by Bearer Web Developer start
    const filteredParcelTypes = parcelTypes.filter(p => p.is_shown_for_orders)
        .sort((a, b) => (Number(a?.list_index_on_the_apps) - Number(b.list_index_on_the_apps)));
    // filteredParcelTypes added by Bearer Web Developer end

    React.useEffect(() => {
        appState.fetchParcelTypes();
    }, [appState]);

    const [loading, setLoading] = React.useState(false);
    const handleConfirm = async () => {
        // added by Bearer Web Developer start
        // Firebase Analytics Event Name Parcel Type Chosen (Final)
        // App Event Parcel Type Confirmed by User
        if (appState?.selectedOrder?.parcelType?.type) {
            logEvent(analytics, "parcel_type_picked", {
                parcel_type: appState?.selectedOrder?.parcelType?.type?.parcel_type
            });
        }
        // added by Bearer Web Developer end
        try {
            setLoading(true);
            const r = await appState.selectedOrder?.fetchPricing();
            setLoading(false);
            r && transport.setEditing(true);
            if (r) appState.selectedOrder?.setAutoSelectTransport(true); // added by Bearer Web Developer
        } catch (err) {
            error(err); // modify by Bearer Web Developer
        }
    }
    // modified by Bearer Web Developer start
    return (
        <div className={styles.root} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.header}>
                <div>
                    <h2>Parcel Type</h2>
                </div>
                <Button variant="text" disableRipple={true} className={styles.clear} onClick={() => parcel.clear()}>Clear</Button>
            </div>
            <List component="nav" className={styles.list} aria-label="mailbox folders">
                {filteredParcelTypes.map((parcelType, i) => <ParcelOption key={i} parcelType={parcelType} parcel={parcel} // change parcelTypes to filteredParcelTypes by Bearer Web Developer
                />)}
                {parcelTypes.length === 0 &&
                    <div className={styles.circular_progress}>
                        <CircularProgress />
                    </div>
                }
            </List>
            <div>
                <Button
                    className={styles.confirm}
                    onClick={handleConfirm}
                    disabled={loading}
                    disableRipple={true}
                >
                    Confirm
                </Button>
                {loading && <DisabledClickLoading />}
            </div>

        </div>
    )
    // modified by Bearer Web Developer end
});
export default ParcelEditor; // ParcelsEditor name changed to ParcelEditor by Bearer Web Developer - ParcelsEditor to ParcelEditor

const ParcelOption: React.FC<{ parcelType: ParcelType, parcel: IParcelState }> = observer(({ parcelType, parcel }) => {

    const selected = parcel.type?.parcel_type === parcelType.parcel_type;

    const handleParcelTypeSelected = () => {
        parcel.selectType(parcelType);
    }
    // modified by Bearer Web Developer start
    return (
        <ListItem onClick={handleParcelTypeSelected} className={`${styles.list_item} ${selected ? styles.selected : ''}`}>
            <div className={styles.type}>
                <div className={styles.image}>
                    <img src={parcelType.parcel_img_fetch_url} alt="" height={55} /> {/* modified by Bearer Web Developer parcel_img_url chaneged to parcel_img_fetch_url*/}
                </div>
                <div className={''} >{parcelType.parcel_type}</div>
            </div>
            <div className={styles.description}>
                <div>{parcelType.parcel_min_weight} ~ {parcelType.parcel_max_weight} kg max</div>
                <div>{parcelType.parcel_description}</div>
            </div>
        </ListItem>
    )
    // modified by Bearer Web Developer end
});

